  import { ConfigCreative, ImageLayerProps, extractText } from '@lidojs/design-editor';
  import {
    RedirectionProps,
  } from '../../generateRedirectionHTML';
  import { generateValidURL } from '../../generateValidURL';
  import { PageExport, containerPremium } from '../generatePremiumHTML';
  import { generatePremiumRedirect } from '../generatePremiumRedirect';

  interface IConfigCreativeOrb {
    [key: string]: ConfigCreative;
  }


  export const generateOrb = async ({
    page,
    hasMobileFrame,
    pages,
  }: PageExport) => {
    const { ROOT: container, ...components } = page;

    const resources = {
      image1: {
        url: (components.bg_image.props as unknown as ImageLayerProps).image
          ?.url,
        hyperlink: components.bg_image.props.hyperlink,
      },
      image2: {
        url: (components.product_image.props as unknown as ImageLayerProps).image
          ?.url,
        hyperlink: components.product_image.props.hyperlink,
      },
      welcomeText: extractText(components.welcome_message.props?.text as string),
      promptSystem: (container.props?.configCreative as IConfigCreativeOrb)?.promptSystem?.value || '{}',
      brandColor1: (container.props?.configCreative as IConfigCreativeOrb)?.brandColor1?.value || 'rgb(0, 0, 0)',
      brandColor2: (container.props?.configCreative as IConfigCreativeOrb)?.brandColor2?.value || 'rgb(226, 0, 41)',
    };

    let promptId;
    try {
      const promptSystemData = JSON.parse(resources.promptSystem as string);
      const response = await fetch('https://ai.service.test.wortise.com/orbe/prompts', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(promptSystemData),
      });
      const data = await response.json();
      if (data?.id) {
        promptId = parseInt(data.id, 10);
      }
    } catch (error) {
      console.error('Error sending promptSystem to API:', error);
      throw error;
    }

    const containerHyperlink = container.props.hyperlink as RedirectionProps;
    const redirectionContainer = generatePremiumRedirect(
      containerHyperlink
    );

    return `
        <title>Creative Premium: Orb</title>
        ${(containerHyperlink?.hasHyperlink && containerHyperlink?.typeLink === "click-tag") ? (
          `<script type="text/javascript">
            var clickTag = "${generateValidURL(
              (container?.props?.hyperlink as RedirectionProps)?.linkRedirect
            )}";
          </script>`
        ) : ''}
        ${orbStyles({
          bgImage: resources.image1.url,
          mainImage: resources.image2.url,
          brandColor1: resources.brandColor1,
          brandColor2: resources.brandColor2
        })}

      </head>
      <body>
        ${containerPremium(hasMobileFrame)}
        <div class="container">
          <div class="app">
            <section class="product initial" ${redirectionContainer}>
              <!-- Imagen principal -->
              <img
                class="main-image"
                src="${resources.image2.url}"
                alt="Image"
                height="100%"
              />
              <!-- Logo en la esquina superior izquierda -->

              <!-- Texto superpuesto
              <div class="text-overlay">
                <div>Dog Chow</div>
                <div class="highlight">nutrición completa</div>
                <div>para toda una vida juntos</div>
              </div> -->
            </section>

            <section class="chat">
              <div class="chat-messages" id="chatMessages"></div>
              <div class="typing" id="typingIndicator">
                <span id="dots">Escribiendo…</span>
              </div>
              <div class="chat-inputbar">
                <input
                  id="chatInput"
                  class="chat-input"
                  placeholder="Escribe tu pregunta aquí..."
                  onkeypress="handleKeyPress(event)"
                />
                <button id="sendBtn" class="send" onclick="sendMessage()">
                  <svg
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    width="18"

                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        stroke="#ffffff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 18V2m0 0l7 7m-7-7L3 9"
                      ></path>
                    </g>
                  </svg>
                </button>
              </div>
            </section>
          </div>
        </div>
        </div>
        ${hasMobileFrame ? '</div>' : ''}
      </div>
      ${orbJs1({
        welcomeText: resources.welcomeText,
        promptId: promptId,
      })}

    `;
  };

  const orbJs1 = ({
    welcomeText,
    promptId
  }) => `
    <script>
      const ORBE_ENDPOINT =
          "https://ai.service.wortise.com/chats/orbe/send";
        const PROMPT_ID = ${promptId};
        let instanceId = null; // Se captura del primer chunk del stream

        const chatMessages = document.getElementById("chatMessages");
        const chatInput = document.getElementById("chatInput");
        const sendBtn = document.getElementById("sendBtn");
        const typingIndicator = document.getElementById("typingIndicator");
        const chatSection = document.querySelector(".chat");
        const appSection = document.querySelector(".app");
        const productSection = document.querySelector(".product");
        const rootElement = document.getElementById("ROOT");


        // Toggle chat messages visibility on input focus
        let hasInteracted = false;

        chatInput.addEventListener("focus", () => {
          chatSection.classList.add("focused");
          appSection.classList.add("chat-focused");
          rootElement.classList.add("chat-focused");
          productSection.classList.remove("initial");
          if (!hasInteracted) {
            hasInteracted = true;
          }
        });

        chatInput.addEventListener("blur", () => {
          // Keep focused if there are messages
          setTimeout(() => {
            const hasMessages = chatMessages.children.length > 0;
            if (!chatInput.matches(":focus") && !hasMessages) {
              chatSection.classList.remove("focused");
              appSection.classList.remove("chat-focused");
              rootElement.classList.remove("chat-focused");
            }
          }, 200);
        });

        function handleKeyPress(e) {
          if (e.key === "Enter") {
            e.preventDefault();
            sendMessage();
          }
        }

        function scrollToBottom() {
          setTimeout(() => {
            chatMessages.scrollTop = chatMessages.scrollHeight;
          }, 0);
        }

        // Función para renderizar markdown básico
        function renderMarkdown(text) {
          return text
            // Encabezados
            .replace(/^### (.*$)/gim, '<h3>$1</h3>')
            .replace(/^## (.*$)/gim, '<h2>$1</h2>')
            .replace(/^# (.*$)/gim, '<h1>$1</h1>')
            // Texto en negrita
            .replace(/\\*\\*(.*?)\\*\\*/g, '<strong>$1</strong>')
            // Texto en cursiva
            .replace(/\\*(.*?)\\*/g, '<em>$1</em>')
            // Código inline
            .replace(/\`(.*?)\`/g, '<code>$1</code>')
            // Listas con viñetas
            .replace(/^\\* (.+)$/gim, '<li>$1</li>')
            .replace(/^- (.+)$/gim, '<li>$1</li>')
            // Envolver listas con viñetas en <ul>
            .replace(/((<li>.*<\\/li>\\s*)+)/gs, '<ul>$1</ul>')
            // Listas numeradas
            .replace(/^\\d+\\. (.+)$/gim, '<li>$1</li>')
            // Limpiar saltos de línea dentro de listas
            .replace(/(<\\/li>)\\s*\\n\\s*(<li>)/g, '$1$2')
            .replace(/(<ul>)\\s*\\n\\s*/g, '$1')
            .replace(/\\s*\\n\\s*(<\\/ul>)/g, '$1')
            .replace(/(<ol>)\\s*\\n\\s*/g, '$1')
            .replace(/\\s*\\n\\s*(<\\/ol>)/g, '$1')
            // Saltos de línea
            .replace(/\\n(?![^<]*>)/g, '<br>')
            // Limpiar br después de elementos de bloque
            .replace(/(<\\/h[1-3]>)<br>/g, '$1')
            .replace(/(<\\/ul>)<br>/g, '$1')
            .replace(/(<\\/ol>)<br>/g, '$1');
        }



        function addMessage(text, sender, useHTML = false) {
          const d = document.createElement("div");
          d.className = \`message \${sender}\`;
          if (useHTML) {
            d.innerHTML = text;
          } else {
            d.textContent = text;
          }
          chatMessages.appendChild(d);
          scrollToBottom();
          return d;
        }

        function addButtons(buttons) {
          const container = document.createElement("div");
          container.className = "button-container";

          buttons.forEach((buttonData) => {
            const btn = document.createElement("a");
            btn.className = "chat-button";
            btn.textContent = buttonData.buttonText;
            btn.href = buttonData.url;
            btn.target = "_blank";
            btn.rel = "noopener noreferrer";
            btn.style.textDecoration = "none";
            btn.style.display = "inline-block";
            container.appendChild(btn);
          });

          chatMessages.appendChild(container);
          scrollToBottom();
          return container;
        }

        function showTyping() {
          typingIndicator.style.display = "block";
          scrollToBottom();
        }

        function hideTyping() {
          typingIndicator.style.display = "none";
          scrollToBottom();
        }

        async function sendMessage() {
          const message = chatInput.value.trim();
          if (!message) return;

          chatInput.disabled = true;
          sendBtn.disabled = true;
          addMessage(message, "user");
          chatInput.value = "";
          showTyping();

          try {
            // Preparar el body del POST
            const body = {
              prompt: PROMPT_ID,
              data: message,
            creative: "{bannerid}"
            };

            // Solo incluir instance si ya existe (a partir del segundo mensaje)
            if (instanceId) {
              body.instance = instanceId;
            }

            const response = await fetch(ORBE_ENDPOINT, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "text/event-stream",
              },
              body: JSON.stringify(body),
            });

            if (!response.ok) {
              throw new Error("Network error");
            }

            hideTyping();

            // Crear elemento para el mensaje de la IA
            const aiMessageElement = addMessage("", "ai");
            let fullResponse = "";
            let buttons = [];

            // Leer el stream
            const reader = response.body.getReader();
            const decoder = new TextDecoder();

            while (true) {
              const { done, value } = await reader.read();

              if (done) {
                console.log("[v0] Stream finalizado");
                break;
              }

              // Decodificar el chunk
              const chunk = decoder.decode(value, { stream: true });
              const lines = chunk.split("\\n").filter((line) => line.trim());

              for (const line of lines) {
                try {
                  const json = JSON.parse(line);

                  // Capturar el instance del primer chunk
                  if (json.instance && !instanceId) {
                    instanceId = json.instance;
                    console.log("[v0] Instance ID capturado:", instanceId);
                  }

                  // Concatenar los textos de respuesta
                  if (json.text) {
                    fullResponse += json.text;
                    aiMessageElement.innerHTML = renderMarkdown(fullResponse);
                    scrollToBottom();
                  }

                  if (json.button) {
                    buttons.push(json.button);
                    console.log("[v0] Botón capturado:", json.button);
                  }
                } catch (e) {
                  // Ignorar líneas que no sean JSON válido
                  console.warn("[v0] Chunk no es JSON válido:", line);
                }
              }
            }

            // Si no hubo respuesta, mostrar mensaje por defecto
            if (!fullResponse) {
              aiMessageElement.innerHTML = renderMarkdown(
                "Lo siento, no pude procesar tu pregunta. ¿Podrías intentar de nuevo?"
              );
            }

            if (buttons.length > 0) {
              addButtons(buttons);
            }
          } catch (err) {
            console.error("[v0] Error en sendMessage:", err);
            hideTyping();
            addMessage(
              renderMarkdown("Lo siento, hay un problema de conexión. Por favor intenta más tarde."),
              "ai",
              true
            );
          } finally {
            chatInput.disabled = false;
            sendBtn.disabled = false;
          }
        }

        const updateKeyboard = () => {
          const open =
            window.visualViewport &&
            window.visualViewport.height < window.innerHeight - 150;
          document.body.classList.toggle("keyboard-open", !!open);
          scrollToBottom();
        };

        if (window.visualViewport) {
          visualViewport.addEventListener("resize", updateKeyboard);
          visualViewport.addEventListener("scroll", updateKeyboard);
        }

        window.addEventListener("resize", updateKeyboard);

        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(() => {
            chatSection.classList.add("focused");
            appSection.classList.add("chat-focused");
          addMessage(renderMarkdown("${welcomeText}"), "ai", true);
          }, 2000);
        });
    </script>
  `;

  const orbStyles = ({
    bgImage,
    mainImage,
    brandColor1,
    brandColor2
  }) => `
      <style>
        :root {
          /* Colores de marca */
          --brand-1: ${brandColor1};
          --brand-2: ${brandColor2};
          --text: #ffffff;
          --bg: ${brandColor2};

          /* Imágenes */
          --bg-image: url(${bgImage});
          --main-image: url(${mainImage});

          /* Texto overlay */
          --text-line1: "Llena de";
          --text-line2: "magia";
          --text-line3: "tu hogar";
          --highlight-color: #b9c942;
        }
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        html,
        body {
          height: 100%;
          width: 100%;
          overflow: hidden;
          background: var(--bg);
          font-family: Inter, system-ui, Segoe UI, Roboto, Helvetica, Arial,
            sans-serif;
          color: var(--text);
        }
        .app {
          height: 100%;
          display: flex;
          flex-direction: column;
          padding: 4%;
          position: relative;
          z-index: 1;
          gap: 2%;
          justify-content: space-between;
        }

        /* Set ROOT div to full width when chat is focused */
        #ROOT.chat-focused {
          width: 100% !important;
        }

        /* Sección de producto/imagen principal */
        .product {
          min-height: 225px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          position: relative;
        }
        .product.initial {
          flex: 1;
        }

        .product img.main-image {
          width: 100%;
          height: auto;
          object-fit: fill;
          object-position: center;
          filter: brightness(1);
          border-radius: 24px;
        }
        .product::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;

          pointer-events: none;
        }
        /* Logo en la esquina superior izquierda */
        .product .logo {
          position: absolute;
          top: 3%;
          left: 4%;
          width: 40px;
          height: auto;
          z-index: 2;
        }
        /* Texto superpuesto sobre la imagen */
        .product .text-overlay {
          position: absolute;
          top: 13%;
          left: 4%;
          color: #fff;
          font-family: "Helvetica Now Display", "Helvetica Neue", Helvetica, Arial,
            sans-serif;
          font-weight: 400;
          /* Reducido de 5rem a 3.5rem para evitar que se pise con el borde */
          font-size: 3.5rem;
          line-height: 1.1;
          text-align: left;
          z-index: 2;
          display: flex;
          flex-direction: column;
          gap: 2px;
        }
        /* Palabra destacada en el texto */
        .product .text-overlay .highlight {
          color: var(--highlight-color);
          font-weight: 800;
        }
        .app.chat-focused .product .text-overlay {
          top: 16%;
          transition: top 0.3s ease;
        }
        .app.chat-focused .product {
          flex: none;
        }
        .app.chat-focused .product img.main-image {
          height: 100%;
        }
        .wrap {
          width: min(980px, 100%);
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
          place-items: center;
          text-align: center;
        }
        .lockup {
          display: flex;
          gap: 10px;
          align-items: center;
          justify-content: center;
          opacity: 0.95;
        }
        .badge {
          width: 42px;
          height: 42px;
          border-radius: 12px;
          background: #000000;
          color: var(--brand-1);
          display: grid;
          place-items: center;
          font-weight: 900;
        }
        .brand {
          font-weight: 900;
          letter-spacing: 0.3px;
        }

        .title {
          font-weight: 900;
          line-height: 1.1;
          font-size: clamp(22px, 4.6vw, 44px);
        }
        .subtitle {
          opacity: 0.95;
          line-height: 1.4;
          font-size: clamp(13px, 2.2vw, 18px);
          max-width: 760px;
        }

        .chips {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          justify-content: center;
          opacity: 0.95;
        }
        .chip {
          border: 1px solid rgba(255, 255, 255, 0.35);
          border-radius: 999px;
          padding: 6px 10px;
          font-size: 12px;
          backdrop-filter: blur(6px);
          background: rgba(255, 255, 255, 0.12);
        }

        .container {
          aspect-ratio: 1080 / 1920;
          height: 100%;
          margin: 0 auto;
          position: relative;
          overflow: hidden;
        }
        /* Imagen de fondo con blur */
        .container::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: var(--bg-image);
          background-size: cover;
          background-position: center;
          filter: blur(6px);
          z-index: 0;
        }

        @media (max-width: 768px) {
          .container {
            width: 100%;
            height: 100%;
            aspect-ratio: auto;
            margin: 0;
          }
        }

        @media (max-width: 500px) {
          .product .text-overlay {
            /* Reducido de 4rem a 2.5rem para mobile */
            font-size: 2.5rem;
          }
        }

        .cta {
          margin-top: 8px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          border: 0;
          border-radius: 14px;
          cursor: pointer;
          background: #fff;
          color: #2a004a;
          padding: 14px 20px;
          font-weight: 900;
          box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
          font-size: clamp(14px, 2.6vw, 18px);
          transition: transform 0.15s ease, box-shadow 0.15s ease,
            opacity 0.2s ease;
          text-decoration: none;
          white-space: nowrap;
        }
        .cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 28px rgba(0, 0, 0, 0.22);
        }
        .cta:active {
          transform: translateY(0);
          opacity: 0.9;
        }

        /* Sección de chat (colapsada por defecto) */
        .chat {
          flex: 0 0 auto;
          min-height: 0;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          background: #fff;
          border-top: 1px solid #e8edf5;
          transition: flex 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          border-radius: 24px;
        }
        /* Chat expandido cuando tiene focus */
        .chat.focused {
          flex: 1;
          padding-bottom: 4px;
          animation: chatExpand 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }
        @keyframes chatExpand {
          0% {
            opacity: 0.95;
            transform: translateY(5px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .chat-header {
          background: linear-gradient(135deg, var(--brand-1), var(--brand-2));
          color: #fff;
          font-weight: 800;
          padding: 10px 14px;
          font-size: 14px;
        }
        .chat-messages {
          flex: 1;
          min-height: 0;
          overflow-y: auto;
          padding: 10px;
          display: none;
          flex-direction: column;
          gap: 10px;
          background: #ffffff;
        }
        .chat.focused .chat-messages {
          display: flex;
        }
        .message {
          max-width: 80%;
          padding: 10px 12px;
          border-radius: 14px;
          font-size: 13px;
          line-height: 1.45;
        }
        .message.user {
          background: var(--brand-2);
          color: #ffffff;
          align-self: flex-end;
          border-bottom-right-radius: 6px;
          font-weight: 600;
        }
        .message.ai {
          background: #ffffff00;
          color: #1f2937;
          align-self: flex-start;
          border: 1px solid #e9eef500;
          border-bottom-left-radius: 6px;
        }
        .button-container {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          align-self: flex-start;
          max-width: 80%;
          margin-top: 4px;
        }
        .chat-button {
          background: var(--brand-2);
          color: #ffffff;
          border: 1px solid var(--brand-1);
          border-radius: 999px;
          padding: 8px 16px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;
        }
        .chat-button:hover {
          background: var(--brand-1);
          color: #fff;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(240, 9, 9, 0.25);
        }
        .chat-button:active {
          transform: translateY(0);
        }
        .typing {
          display: none;
          align-self: flex-start;
          background: #fff;
          border: 1px solid #e9eef5;
          border-radius: 14px;
          border-bottom-left-radius: 6px;
          padding: 8px 12px;
          font-size: 13px;
          color: #667084;
          max-width: 80%;
          margin: 0 10px 10px;
        }
        .chat-inputbar {
          padding: 10px;
          background: #fff;
          border-top: 1px solid #e9eef5;
          display: flex;
          gap: 8px;
        }
        .chat-input {
          flex: 1;
          border: 1px solid #d5d9e2;
          border-radius: 999px;
          padding: 10px 16px;
          font-size: 16px;
          outline: none;
          transition: all 0.3s ease;
        }
        .chat-input:focus {
          border-color: var(--brand-1);
          box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08),
                      0 2px 6px rgba(0, 0, 0, 0.12),
                      0 6px 12px rgba(0, 0, 0, 0.10),
                      0 12px 24px rgba(0, 0, 0, 0.08);
          transform: translateY(-1px);
        }
        .send {
          background: var(--brand-1);
          color: #000000;
          border: none;
          border-radius: 50%;
          width: 38px;
          height: 38px;
          cursor: pointer;
          display: grid;
          place-items: center;
          font-size: 16px;
        }
        .send:disabled {
          background: #ffffff;
          cursor: not-allowed;
        }

        .keyboard-open .product {
          flex: 0 0 75%;
          overflow: hidden;
        }
        .keyboard-open .product img {
          object-position: center center;
        }
        .keyboard-open .chat {
          flex: 0 0 25%;
          min-height: 0;
          overflow: hidden;
        }

        .disclaimer {
          text-align: center;
          font-size: 11px;
          color: #000000;
          padding: 0 8px 0 0;
          opacity: 0.8;
        }

        /* Estilos para contenido markdown */
        .message.ai h1, .message.ai h2, .message.ai h3 {
          margin: 0.5em 0 0.3em 0;
          font-weight: bold;
        }
        .message.ai h1 { font-size: 1.2em; }
        .message.ai h2 { font-size: 1.1em; }
        .message.ai h3 { font-size: 1.05em; }

        .message.ai strong {
          font-weight: 700;
        }

        .message.ai em {
          font-style: italic;
        }

        .message.ai code {
          background-color: #f1f5f9;
          color: #374151;
          padding: 0.125rem 0.25rem;
          border-radius: 0.25rem;
          font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
          font-size: 0.875em;
        }

        .message.ai ul, .message.ai ol {
          margin: 0.5em 0;
          padding-left: 1.2em;
        }

        .message.ai li {
          margin: 0.2em 0;
        }

        .message.ai ul li {
          list-style-type: disc;
        }

        .message.ai ol li {
          list-style-type: decimal;
        }
      </style>
  `;
